let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aRdfn")).then(() => parcelRequire('icLxk'));